module.exports = __webpack_public_path__ + "img/uk-neoplasm-female.17869109.png";